import { Virtuoso } from 'react-virtuoso';
import useChatHistory from '../../../hooks/chat-history';
import ChatListEmptyList from './empty-state';
import HistoryCard from './card';
import { Box } from '@mui/joy';

export default function ChatHistory() {
	const { chatHistory } = useChatHistory();

	if (!chatHistory || chatHistory.length === 0) {
		return <ChatListEmptyList />;
	}

	return (
		<Virtuoso
			totalCount={chatHistory.length}
			itemContent={index => (
				<Box sx={{ mb: 2, px: 2 }}>
					<HistoryCard
						historicalChat={chatHistory[index]}
						key={chatHistory[index].chat_id}
					/>
				</Box>
			)}
		/>
	);
}
